import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vendor-popular-courses',
  templateUrl: './vendor-popular-courses.component.html',
  styleUrls: ['./vendor-popular-courses.component.scss']
})
export class VendorPopularCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
